import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState('');

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    const form = e.target as HTMLFormElement;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6k6s1qg895l60t541b0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubscribeStatus('success');
        setEmail('');
        setTimeout(() => setSubscribeStatus(''), 3000);
      } else {
        setSubscribeStatus('error');
      }
    } catch (error) {
      setSubscribeStatus('error');
    }
  };

  return (
    <footer className="bg-[#06B6D4] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Left Column - Brand */}
          <div className="md:col-span-5">
            <img
              src="https://static.readdy.ai/image/1a26ac5983f572a98909fa1cfb0c220a/9efa73a4de54dc9e9bbf665ad1b8c213.png"
              alt="CZ Creative Media"
              className="h-24 w-auto mb-4 filter brightness-0 invert"
            />
            <p className="text-base text-white/90 mb-6 max-w-sm">
              Transforming visions into visual reality through creative design, impactful signage, and professional print solutions.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/40 flex items-center justify-center hover:bg-white hover:text-[#06B6D4] transition-all duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/40 flex items-center justify-center hover:bg-white hover:text-[#06B6D4] transition-all duration-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/40 flex items-center justify-center hover:bg-white hover:text-[#06B6D4] transition-all duration-200 cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://behance.net"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/40 flex items-center justify-center hover:bg-white hover:text-[#06B6D4] transition-all duration-200 cursor-pointer"
              >
                <i className="ri-behance-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Middle Column - Links & Contact */}
          <div className="md:col-span-3">
            <h3 className="text-xs font-semibold uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/portfolio" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  Portfolio
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-white/90 hover:text-white transition-colors cursor-pointer">
                  Contact
                </Link>
              </li>
            </ul>

            <h3 className="text-xs font-semibold uppercase tracking-wider mt-8 mb-4">Contact Info</h3>
            <div className="space-y-2 text-sm text-white/90">
              <p></p>
              <p></p>
              <p className="mt-3">856-213-2918</p>
              <p>sales@czcreativemedia.net</p>
            </div>
          </div>

          {/* Right Column - Newsletter */}
          <div className="md:col-span-4">
            <h3 className="text-xs font-semibold uppercase tracking-wider mb-4">Newsletter</h3>
            <p className="text-sm text-white/90 mb-4">
              Get design tips and exclusive offers delivered to your inbox.
            </p>
            <form onSubmit={handleSubscribe} data-readdy-form id="newsletter-form">
              <div className="flex">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  required
                  className="flex-1 px-4 py-2.5 rounded-l-lg text-sm text-gray-900 focus:outline-none focus:ring-2 focus:ring-white"
                />
                <button
                  type="submit"
                  className="bg-gray-900 text-white px-6 py-2.5 rounded-r-lg text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap"
                >
                  Subscribe
                </button>
              </div>
              {subscribeStatus === 'success' && (
                <p className="text-sm text-white mt-2">Thank you for subscribing!</p>
              )}
              {subscribeStatus === 'error' && (
                <p className="text-sm text-red-200 mt-2">Something went wrong. Please try again.</p>
              )}
            </form>

            <div className="mt-6 rounded-xl overflow-hidden h-48 w-full">
              <img
                src="https://public.readdy.ai/ai/img_res/49d41f6a266d0d51277d424a791dd6eb.jpg"
                alt="Our Studio"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-white/20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-white/80">
            <p>&copy; 2026 CZ Creative Media LLC. All rights reserved.</p>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}